import { render, staticRenderFns } from "./MedalStanding.vue?vue&type=template&id=3e0f6c66&"
import script from "./MedalStanding.vue?vue&type=script&lang=js&"
export * from "./MedalStanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports